'use client'

import { useState } from "react"
import ButtonBadge from "@/components/button/ButtonBadge"
import { formatCurrency } from "@/utils/Formatters"
import { DM_EVENT_TRADE_ESTIMATE, useDMEventListener } from "@dealermesh/react"
import useEventListener from '@/components/plugins/EventListener';

export default function TradeIndicator(props) {

  const [trade,setTrade] = useState(props.site?.session?.vehicles?.trade)

  useDMEventListener(DM_EVENT_TRADE_ESTIMATE, event => {
    if (event.detail?.value) {
      setTrade(event.detail)
    }
  })

  useEventListener("trade_removed", event => {
    setTrade(null)
  })

  if (trade) {
    if (props.inline) {

    } else {
      return props.children ? props.children : <ButtonBadge theme={props.theme}>{ formatCurrency(trade?.value) }</ButtonBadge>
    }
  } else {
    return null
  }

}